module.exports = "/img/6.8e5f80.webp";